import React from 'react';
import ProjectDashboard from '../components/ProjectDashboard';
import Pageheader from '../utils/headerHelment';
import { isMobile, isTablet } from 'react-device-detect';
import DoubleConfirmationModal from '../components/CommonComponents/DoubleConfirmationModal/DoubleConfirmationModal';
import { usePulseModal } from '../components/Pulse/PulseModalContext';
import { setProjectImg } from '../redux/projectDataSlice';
import Cookies from 'js-cookie';
import { setDocs } from '../redux/documentsSlice';
import { logoutWithAudit } from '../redux/usersSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
const ProjectPage = () => {
    const triggerWarnModalRef = React.useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const memberships = useSelector(state => state?.user?.memberships || []);
    const activeWorkspaceId = useSelector(state => state?.user?.activeWorkspaceId);
    const { tryAutoOpenOnProjects } = usePulseModal();
    const mobileDeviceWarn = localStorage?.getItem('mobileDeviceWarn');

    console.log({ mobileDeviceWarn });
    React.useEffect(() => {
        if (isMobile || isTablet) {
            if (!mobileDeviceWarn) {
                if (triggerWarnModalRef?.current) {
                    console.log(triggerWarnModalRef?.current?.click());
                }
            }
        }
    }, [triggerWarnModalRef, mobileDeviceWarn]);

    React.useEffect(() => {
        // If user has multiple workspaces and hasn't selected one yet, force selection before loading projects.
        if (memberships.length > 1 && !activeWorkspaceId) {
            navigate('/select-workspace', { replace: true });
        }
    }, [memberships, activeWorkspaceId, navigate]);

    React.useEffect(() => {
        if (!activeWorkspaceId) return;
        tryAutoOpenOnProjects();
    }, [activeWorkspaceId, tryAutoOpenOnProjects]);

    const handleLogout = async () => {
        localStorage.removeItem('persist:root');
        // Clear project dashboard filters/preferences when user logs out
        localStorage.removeItem('projectDashboardFilters');
        Cookies.set('refresh', '');
        dispatch(setProjectImg(''));
        dispatch(setDocs([]));
        await dispatch(logoutWithAudit());
        navigate('/');
    };
    return (
        <>
            <Pageheader title="LENS - Dashboard" />
            {/* <Project /> */}
            <ProjectDashboard />
            <DoubleConfirmationModal
                handleAction={() => localStorage.setItem('mobileDeviceWarn', true)}
                modalOneBtnL="Continue"
                modalOneBtnR="Logout"
                modalTwoBtnR="Continue"
                firstModalActionBtn={handleLogout}
                message={
                    'Please note that Lens is best experienced on a desktop browser. Using a mobile or tablet may significantly impact functionality and your user experience.'
                }>
                <span ref={triggerWarnModalRef}></span>
            </DoubleConfirmationModal>
        </>
    );
};

export default ProjectPage;
